<template>
  <div v-if="item">
    <fields-list :item="item" :fields="fields" />
   <div class="save-panel">
          <button class="btn btn-sm btn-warning btn-icon" @click="updateItem">
               <span class="ti-save"></span>Сохранить
          </button>
    </div>
  </div>
</template>

<script>
import { cardUpdate, cardContent, pushLang } from "@/plugins/functions";

export default {
  data: () => ({
    cardLink: "posts",
    cardSetLink: "posts",
    item: null,
    fields: [
           {
            col:' col-12 col-md-12',
            key: "title",
            label: "Название",
            type: "field",
            textType: "text",
            isMultiLang:true
          },
       
                {
                key: "position",
                label: "Позиция",
                type: "field",
                textType: "number",
                
              },

                 {
                  col:' col-12 col-md-6 ',
                  key: "is_active",
                  label: "Активность",
                  type: "checkbox",
              },
                {
                key: "code",
                label: "Ссылка",
                type: "field",
                textType: "text",
                
              },
            {
                col:' col-12 col-md-4 ',
                key: "image",
                label: "Изображение (2:1)",
                type: "img",
                 isMultiLang:true
            },
               {
            col:' col-12 col-md-12',
            key: "annotation",
            label: "Краткое описание",
            type: "textarea",
            textType: "text",
            isMultiLang:true
          },
    ],
  }),

  props: ["id"],
  async created() {
    // this.pushLang();
    this.item = await this.cardContent(this.cardLink, this.id);
  },
  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,
    pushLang: pushLang,
    async updateItem() {
      let item = await this.cardUpdate(this.cardSetLink, this.item, this.fields);
    },
  },
};
</script>
<style>
</style>
